export default "__VITE_ASSET__ctWJrpt0__"